import { Crown } from 'lucide-react'
import { ModalOverlay } from './ModalOverlay'

const F = 'Roboto, sans-serif'

interface Props {
  open: boolean
  onClose: () => void
  level?: number
  product?: string
}

const PRODUCT_LABELS: Record<string, string> = {
  TFA_STEP1: 'ТФА 1',
  TFA_STEP2: 'ТФА 2',
  CLUB: 'Клуб',
}

export function LevelCapModal({ open, onClose, level = 10, product = 'TFA_STEP1' }: Props) {
  const productLabel = PRODUCT_LABELS[product] || product

  return (
    <ModalOverlay open={open} onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: F, gap: 12 }}>
        <div style={{
          width: 80, height: 80, borderRadius: 40,
          background: 'linear-gradient(135deg, rgba(255,215,0,0.2), rgba(255,149,0,0.1))',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          animation: 'pulse-glow 2s ease-in-out infinite',
        }}>
          <Crown size={40} color="#FFD700" />
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1C2D41', margin: 0, textAlign: 'center' }}>
          Уровень {level} — Максимум!
        </h2>
        <p style={{ fontSize: 15, color: '#6B7B8D', margin: 0, textAlign: 'center', lineHeight: 1.5 }}>
          Ты достиг максимального уровня для {productLabel}. Опыт продолжает копиться в Банк XP.
        </p>
        <div style={{
          padding: '8px 16px', borderRadius: 12,
          background: 'rgba(108,92,231,0.08)', border: '1px solid rgba(108,92,231,0.15)',
        }}>
          <span style={{ fontSize: 13, color: '#6C5CE7', fontWeight: 600 }}>
            Приобрети следующий курс, чтобы продолжить рост
          </span>
        </div>
        <button onClick={onClose} style={{
          width: '100%', height: 52, borderRadius: 16, border: 'none',
          background: 'linear-gradient(135deg, #1A3A5C, #4A6CF7)',
          color: 'white', fontSize: 16, fontWeight: 700,
          cursor: 'pointer', fontFamily: F, marginTop: 8,
        }}>
          Понятно
        </button>
      </div>
      <style>{`
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255,215,0,0.3); }
          50% { box-shadow: 0 0 20px 4px rgba(255,215,0,0.15); }
        }
      `}</style>
    </ModalOverlay>
  )
}
